import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export interface QuestionnaireActionDialogData {
  title: string;
  message: string;
  continueButtonText: string;
  restartButtonText: string;
}

@Component({
  selector: "app-questionnaire-action-dialog",
  templateUrl: "./questionnaire-action-dialog.component.html",
  styleUrls: ["./questionnaire-action-dialog.component.scss"],
})
export class QuestionnaireActionDialogComponent {
  constructor(public dialogRef: MatDialogRef<QuestionnaireActionDialogComponent>) {}

  /**
   * Closes the dialog with mode
   * @param mode
   */
  public close(mode: string): void {
    this.dialogRef.close(mode);
  }
}
